import { useSessao } from './features/auth/model/useSessao';
import { InicioPage } from './pages/inicio/InicioPage';
import { LoginPage } from './pages/login/LoginPage';

export function App() {
    const { estado, entrarCom, sairDaSessao, tentarNovamente } = useSessao();

    if (estado.tipo === 'verificando') {
        return <main className="pagina-carregando">Verificando acesso...</main>;
    }
    if (estado.tipo === 'autenticado') {
        return <InicioPage usuario={estado.sessao.usuario} csrfToken={estado.sessao.csrfToken} aoSair={sairDaSessao} />;
    }
    return (
        <LoginPage
            aoAutenticar={entrarCom}
            indisponivel={estado.indisponivel}
            aoTentarNovamente={tentarNovamente}
        />
    );
}
